/**
 * @file コンポーネント：アカウントメニュー スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル設定読み込み
import { zIndex } from "~/src/styles/constants";

// スタイル
export const StyledAccountmenu = styled.dl`
    visibility: hidden;
    position: fixed;
    right: 0;
    top: 64px;
    z-index: ${zIndex.headerAccountmenu};
    width: 328px;
    padding: 16px 16px 12px;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.5);
    background-color: #ffffff;

    &.is-open {
        visibility: visible;
    }
`;

export const StyledAccountmenuAnchor = styled.a`
    color: #5f5f5f;
    font-size: 14px;
    line-height: 24px;
`;

export const StyledAccountmenuDetail = styled.dd`
    margin-bottom: 24px;

    &:last-child {
        margin-bottom: 0;
    }
`;

export const StyledAccountmenuDetailName = styled(StyledAccountmenuDetail)`
    color: #5f5f5f;
    font-size: 14px;
    line-height: 20px;
`;

export const StyledAccountmenuItem = styled.div`
    margin-bottom: 16px;

    &:last-child {
        margin-bottom: 0;
    }
`;

export const StyledAccountmenuLabel = styled.label`
    display: inline-flex;
    padding: 4px 0;
    font-size: 14px;
    line-height: 1;
`;

export const StyledAccountmenuLabelRadio = styled.input`
    margin: 0 32px 0 0;
`;

export const StyledAccountmenuTerm = styled.dt`
    margin-bottom: 12px;
    color: #000000;
    font-size: 14px;
    line-height: 24px;

    &.is-notification {
        &::after {
            display: inline-block;
            margin-left: 4px;
            width: 1em;
            height: 1em;
            border-radius: 50%;
            background-color: #ad401f;
            color: #ffffff;
            font-weight: normal;
            font-size: 15px;
            line-height: 1em;
            text-align: center;
            content: "!";
        }
    }
`;

export const StyledAccountmenuTermName = styled(StyledAccountmenuTerm)`
    margin-bottom: 0;
    font-size: 20px;
`;
